import React, { useState, useEffect, useCallback } from "react";

// Format plat nomor Indonesia: B 1234 ABC
const formatPlate = (value) => {
  if (!value) return value;
  const raw = value.toUpperCase().replace(/\s+/g, "");
  const match = raw.match(/^([A-Z]{1,2})(\d{1,4})([A-Z]{0,3})$/);
  if (match) return [match[1], match[2], match[3]].filter(Boolean).join(" ");
  return raw;
};
import { toast } from "react-toastify";
import { Modal, Button, Form, Badge, Tab, Tabs } from "react-bootstrap";
import {
  FiSearch,
  FiPlus,
  FiMinus,
  FiTrash2,
  FiSend,
  FiUser,
  FiTruck,
  FiClock,
  FiGift,
  FiShoppingCart,
  FiCreditCard,
  FiDollarSign,
} from "react-icons/fi";
import api, { parseWIB } from "../services/api";
import { useAuth } from "../contexts/AuthContext";
import ConfirmModal from "../components/ConfirmModal";
import bluetoothPrinter from "../utils/bluetooth";

const POS = () => {
  const { user } = useAuth();
  const [services, setServices] = useState([]);
  const [products, setProducts] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [cart, setCart] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [customerSearch, setCustomerSearch] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [discountType, setDiscountType] = useState("flat");
  const [discountAmount, setDiscountAmount] = useState("");
  const [voucherCode, setVoucherCode] = useState("");
  const [validatedVoucher, setValidatedVoucher] = useState(null);
  const [notes, setNotes] = useState("");
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showCustomerPicker, setShowCustomerPicker] = useState(false);
  const [newCustomer, setNewCustomer] = useState({ name: "", phone: "" });
  const [newVehicles, setNewVehicles] = useState([
    { vehicle_type: "", plate_number: "", brand: "" },
  ]);
  const [activeTab, setActiveTab] = useState("services");
  const [serviceFilter, setServiceFilter] = useState("all");
  const [productFilter, setProductFilter] = useState("all");
  const [loading, setLoading] = useState(false);
  const [loyaltyRules, setLoyaltyRules] = useState([]);
  const [loyaltyEnabled, setLoyaltyEnabled] = useState(false);
  const [showRedeemModal, setShowRedeemModal] = useState(false);
  const [redeemRuleId, setRedeemRuleId] = useState("");
  const [redeemVehicle, setRedeemVehicle] = useState(null);
  const [redeemReplaceItem, setRedeemReplaceItem] = useState(null); // item di keranjang yang akan diganti saat redeem
  const [redeemUpgradeServiceId, setRedeemUpgradeServiceId] = useState(null);
  // Track which loyalty rules have been redeemed into cart: key = `${rule_id}_${vehicle_id}`
  const [redeemedRules, setRedeemedRules] = useState({});
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [serviceCategories, setServiceCategories] = useState([]);
  const [shiftReady, setShiftReady] = useState(false);
  const [showShiftModal, setShowShiftModal] = useState(false);
  const [shiftOpeningCash, setShiftOpeningCash] = useState("");
  const [staleShift, setStaleShift] = useState(null); // shift dari hari sebelumnya yang masih open
  const [showAddVehicleModal, setShowAddVehicleModal] = useState(false);
  const [specialPaymentMethods, setSpecialPaymentMethods] = useState([]);
  const [selectedSpecialPayment, setSelectedSpecialPayment] = useState(null);
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    title: "",
    message: null,
    onConfirm: null,
    confirmLabel: "Lanjutkan",
    confirmVariant: "warning",
    cancelLabel: "Batal",
  });
  const closeConfirm = () =>
    setConfirmModal((prev) => ({ ...prev, show: false, onConfirm: null }));

  const [newVehicle, setNewVehicle] = useState({
    vehicle_type: "",
    plate_number: "",
    brand: "",
  });
  const [posLoyaltyProgressEdit, setPosLoyaltyProgressEdit] = useState({});
  const [posSettings, setPosSettings] = useState({});

  // Check active shift for kasir on mount
  useEffect(() => {
    const checkShift = async () => {
      if (user?.role === "admin") {
        setShiftReady(true);
        return;
      }
      try {
        const res = await api.get("/shifts/current");
        if (res.data.active) {
          if (res.data.is_today) {
            setShiftReady(true);
          } else {
            // Shift dari hari sebelumnya masih open
            setStaleShift(res.data.shift);
            setShowShiftModal(true);
          }
        } else {
          setShowShiftModal(true);
        }
      } catch {
        setShowShiftModal(true);
      }
    };
    checkShift();
  }, [user]);

  const handleContinueShift = () => {
    setStaleShift(null);
    setShowShiftModal(false);
    setShiftReady(true);
  };

  const handleCloseStaleShift = async () => {
    try {
      await api.post("/shifts/close", {
        closing_cash: 0,
        notes: "Auto-close shift hari sebelumnya",
      });
      setStaleShift(null);
      // Modal tetap terbuka, sekarang tampilkan form buka shift baru
    } catch (error) {
      toast.error(error.response?.data?.message || "Gagal menutup shift lama");
    }
  };

  const handleOpenShift = async () => {
    if (!shiftOpeningCash || Number(shiftOpeningCash) < 0) {
      toast.error("Masukkan kas awal yang valid");
      return;
    }
    try {
      await api.post("/shifts/open", {
        opening_cash: Number(shiftOpeningCash),
      });
      toast.success("Shift berhasil dibuka");
      setShowShiftModal(false);
      setShiftOpeningCash("");
      setShiftReady(true);
    } catch (error) {
      toast.error(error.response?.data?.message || "Gagal membuka shift");
    }
  };

  const loadData = useCallback(async () => {
    try {
      const [
        svcRes,
        prodRes,
        custRes,
        settRes,
        vtRes,
        catRes,
        rulesRes,
        pmRes,
      ] = await Promise.all([
        api.get("/services/active"),
        api.get("/products/active"),
        api.get("/customers"),
        api.get("/settings"),
        api.get("/settings/vehicle-types"),
        api.get("/services/categories"),
        api.get("/settings/loyalty-rules"),
        api.get("/payment-methods/active"),
      ]);
      setServices(svcRes.data);
      setProducts(prodRes.data);
      setCustomers(custRes.data);
      setVehicleTypes(vtRes.data.filter((vt) => vt.is_active));
      setServiceCategories(catRes.data || []);
      setLoyaltyRules(rulesRes.data.filter((r) => r.is_active));
      setSpecialPaymentMethods(Array.isArray(pmRes.data) ? pmRes.data : []);
      if (settRes.data) {
        setLoyaltyEnabled(settRes.data.loyalty_enabled === "1");
        setPosSettings(settRes.data);
      }
    } catch (error) {
      toast.error("Gagal memuat data");
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const addToCart = (item, type) => {
    const vehicleId = type === "service" ? selectedVehicle?.id || null : null;

    // Aturan 1: Jika kendaraan ini sudah punya loyalty item di keranjang, blokir penambahan layanan lain
    if (type === "service" && vehicleId) {
      const loyaltyInCart = cart.find(
        (c) =>
          (c.isLoyaltyReward || c.isLoyaltyDiscount) &&
          c.vehicle_id === vehicleId,
      );
      if (loyaltyInCart) {
        const vLabel = vehicleLabel(selectedVehicle) || "kendaraan ini";
        toast.warning(
          `Hapus redeem loyalty dari keranjang terlebih dahulu sebelum menambah layanan lain untuk ${vLabel}.`,
          { autoClose: 4000 },
        );
        return;
      }
    }

    const existing = cart.find(
      (c) => c.id === item.id && c.type === type && c.vehicle_id === vehicleId,
    );
    if (existing) {
      if (type === "product" && existing.quantity >= item.stock) {
        toast.warning(`Stok ${item.name} tidak mencukupi`);
        return;
      }
      setCart(
        cart.map((c) =>
          c.id === item.id && c.type === type && c.vehicle_id === vehicleId
            ? { ...c, quantity: c.quantity + 1 }
            : c,
        ),
      );
    } else {
      setCart([
        ...cart,
        {
          id: item.id,
          type,
          name: item.name,
          price: Number(item.price || item.sell_price),
          quantity: 1,
          maxStock: type === "product" ? item.stock : 999,
          discount: 0,
          vehicle_id: vehicleId,
          vehicle_label:
            type === "service" && selectedVehicle
              ? vehicleLabel(selectedVehicle)
              : null,
          category_name: item.category_name || "",
        },
      ]);
    }
    toast.success(`${item.name} ditambahkan`, {
      autoClose: 1000,
      hideProgressBar: true,
    });

    // Aturan 2: Setelah menambah layanan, cek apakah ada loyalty yang bisa diklaim untuk kendaraan ini
    if (type === "service" && vehicleId && loyaltyEnabled) {
      const vehicle = selectedCustomer?.vehicles?.find(
        (v) => v.id === vehicleId,
      );
      if (vehicle) {
        const claimable = (vehicle.loyalty_progress || []).filter(
          (lp) =>
            lp.redemption_mode !== "auto" &&
            lp.current_count >= lp.required_count &&
            !redeemedRules[`${lp.rule_id}_${vehicleId}`],
        );
        if (claimable.length > 0) {
          const vLabel = vehicleLabel(vehicle);
          const ruleNames = claimable.map((lp) => lp.rule_name).join(", ");
          const firstClaimable = claimable[0];
          setConfirmModal({
            show: true,
            title: "🎁 Ada Hadiah Loyalty!",
            message: (
              <div>
                <p className="mb-2">
                  <strong>{vLabel}</strong> mempunyai hadiah loyalty yang bisa
                  diklaim:
                </p>
                <p className="text-success fw-bold mb-3">{ruleNames}</p>
                <p className="mb-0 text-muted small">
                  Apakah ingin mengganti layanan yang baru ditambahkan dengan
                  klaim loyalti? Jika tidak, progress akan tetap bertambah.
                </p>
              </div>
            ),
            confirmLabel: "Klaim Sekarang",
            confirmVariant: "success",
            cancelLabel: "Lewati",
            onConfirm: () => {
              closeConfirm();
              setRedeemVehicle(vehicle);
              setRedeemRuleId(String(firstClaimable.rule_id));
              setRedeemReplaceItem({
                id: item.id,
                type,
                vehicle_id: vehicleId,
              });
              setShowRedeemModal(true);
            },
          });
        }
      }
    }
  };

  const clearLoyaltyKey = (item) => {
    if (
      (item?.isLoyaltyReward || item?.isLoyaltyDiscount) &&
      item.loyaltyRuleId &&
      item.vehicle_id
    ) {
      const key = `${item.loyaltyRuleId}_${item.vehicle_id}`;
      setRedeemedRules((prev) => {
        const n = { ...prev };
        delete n[key];
        return n;
      });
    }
  };

  const updateQuantity = (index, delta) => {
    const newCart = [...cart];
    const item = newCart[index];
    // Loyalty reward items are fixed at qty 1
    if (item.isLoyaltyReward && delta > 0) return;
    const newQty = item.quantity + delta;
    if (newQty <= 0) {
      clearLoyaltyKey(item);
      newCart.splice(index, 1);
    } else if (item.type === "product" && newQty > item.maxStock) {
      toast.warning("Stok tidak mencukupi");
      return;
    } else {
      item.quantity = newQty;
    }
    setCart(newCart);
  };

  const removeFromCart = (index) => {
    const item = cart[index];
    clearLoyaltyKey(item);
    setCart(cart.filter((_, i) => i !== index));
  };

  const subtotal = cart.reduce(
    (sum, item) => sum + (item.price * item.quantity - (item.discount || 0)),
    0,
  );

  // Loyalty discount: gunakan loyaltyDiscountAmount jika ada (upgrade), fallback ke harga penuh (gratis)
  const loyaltyRewardDiscount = cart
    .filter((i) => i.isLoyaltyReward)
    .reduce((total, loyaltyItem) => {
      const discountAmount = loyaltyItem.loyaltyDiscountAmount ?? loyaltyItem.price;
      return total + discountAmount * loyaltyItem.quantity;
    }, 0);
  const manualDiscount =
    discountType === "percentage"
      ? subtotal * (Number(discountAmount) / 100)
      : Number(discountAmount) || 0;
  const voucherDiscount = validatedVoucher
    ? validatedVoucher.discount_type === "percentage"
      ? subtotal * (validatedVoucher.discount_value / 100)
      : Number(validatedVoucher.discount_value)
    : 0;
  const totalDiscount = manualDiscount + voucherDiscount;
  const baseTotal = Math.max(
    0,
    subtotal - totalDiscount - loyaltyRewardDiscount,
  );
  const serviceQty = cart
    .filter((i) => i.type === "service")
    .reduce((s, i) => s + i.quantity, 0);
  const productSubtotal = cart
    .filter((i) => i.type === "product")
    .reduce((s, i) => s + i.price * i.quantity - (i.discount || 0), 0);
  const total =
    selectedSpecialPayment?.override_price != null
      ? Number(selectedSpecialPayment.override_price) * serviceQty +
        productSubtotal
      : baseTotal;
  const totalItems = cart.reduce((s, i) => s + i.quantity, 0);

  const validateVoucher = async () => {
    if (!voucherCode) return;
    try {
      const res = await api.post("/promos/vouchers/validate", {
        code: voucherCode,
      });
      if (res.data.valid) {
        setValidatedVoucher(res.data.voucher);
        toast.success("Voucher valid!");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Voucher tidak valid");
      setValidatedVoucher(null);
    }
  };

  const openPayOrWarn = () => {
    const warnings = [];
    if (!selectedCustomer) {
      warnings.push("Customer belum dipilih.");
    }
    const servicesWithoutVehicle = cart.filter(
      (item) => item.type === "service" && !item.vehicle_id,
    );
    if (servicesWithoutVehicle.length > 0) {
      const names = [
        ...new Set(servicesWithoutVehicle.map((i) => i.name)),
      ].join(", ");
      warnings.push(`Layanan berikut belum dipilih kendaraannya: ${names}`);
    }
    if (warnings.length > 0) {
      setConfirmModal({
        show: true,
        title: "Perhatian",
        message: (
          <div>
            <ul className="mb-2 ps-3">
              {warnings.map((w, i) => (
                <li key={i}>{w}</li>
              ))}
            </ul>
            <div>Tetap lanjutkan transaksi?</div>
          </div>
        ),
        onConfirm: () => {
          closeConfirm();
          setShowPaymentModal(true);
        },
        confirmLabel: "Tetap Lanjutkan",
        confirmVariant: "warning",
      });
    } else {
      setShowPaymentModal(true);
    }
  };

  const handleCheckout = async () => {
    if (cart.length === 0) {
      toast.error("Keranjang kosong");
      return;
    }
    if (
      paymentMethod !== "unpaid" &&
      paymentMethod !== "special" &&
      paymentMethod === "cash" &&
      Number(paymentAmount) < total
    ) {
      toast.error("Pembayaran kurang");
      return;
    }
    setLoading(true);
    try {
      const items = cart.map((item) => ({
        type: item.type,
        id: item.id,
        quantity: item.quantity,
        discount: item.discount,
        vehicle_id: item.vehicle_id || null,
        isLoyaltyReward: item.isLoyaltyReward || false,
        loyaltyDiscountAmount: item.loyaltyDiscountAmount ?? null,
      }));
      const loyaltyRedemptions = cart
        .filter((i) => i.isLoyaltyReward && i.loyaltyRuleId && i.vehicle_id)
        .map((i) => ({ rule_id: i.loyaltyRuleId, vehicle_id: i.vehicle_id }));
      const res = await api.post("/transactions", {
        customer_id: selectedCustomer?.id,
        vehicle_id: selectedVehicle?.id,
        items,
        payment_method: selectedSpecialPayment ? "special" : paymentMethod,
        payment_amount:
          paymentMethod === "unpaid"
            ? 0
            : paymentMethod === "cash"
              ? Number(paymentAmount)
              : total,
        discount_amount:
          selectedSpecialPayment?.override_price != null
            ? 0
            : manualDiscount + loyaltyRewardDiscount,
        voucher_id:
          selectedSpecialPayment?.override_price != null
            ? undefined
            : validatedVoucher?.id,
        notes,
        special_payment_method_id: selectedSpecialPayment?.id || null,
        special_payment_override_price:
          selectedSpecialPayment?.override_price != null
            ? Number(selectedSpecialPayment.override_price)
            : null,
        loyalty_redemptions: loyaltyRedemptions,
      });
      toast.success(`Transaksi berhasil! ${res.data.invoice_number}`);

      // Notify about rewards auto-claimed within this transaction
      if (Array.isArray(res.data.auto_claimed_rewards)) {
        res.data.auto_claimed_rewards.forEach((r) => {
          toast.success(`🎁 Loyalty terpenuhi! GRATIS ${r.reward_name}`, {
            duration: 6000,
          });
        });
      }

      // Print receipt via Bluetooth if connected
      if (bluetoothPrinter.isConnected()) {
        const printData = {
          invoice_number: res.data.invoice_number,
          id: res.data.id,
          created_at: new Date(),
          cashier_name: user?.full_name || user?.username || "",
          customer_name: selectedCustomer?.name || null,
          plate_number: selectedVehicle?.plate_number || null,
          vehicle_type: selectedVehicle?.vehicle_type || null,
          details: [
            ...cart.map((item) => ({
              item_type: item.type,
              item_name: item.name,
              unit_price: item.price,
              quantity: item.quantity,
              subtotal: item.price * item.quantity,
            })),
            // Rewards auto-granted server-side (free) so they appear on the receipt
            ...(res.data.auto_claimed_rewards || []).map((r) => ({
              item_type: r.reward_item_type === "product" ? "product" : "service",
              item_name: `🎁 ${r.reward_name} (GRATIS Loyalty)`,
              unit_price: 0,
              quantity: 1,
              subtotal: 0,
            })),
          ],
          total_amount: total,
          discount_amount: selectedSpecialPayment ? 0 : manualDiscount,
          paid_amount: paymentMethod === "cash" ? Number(paymentAmount) : total,
          payment_method: selectedSpecialPayment
            ? selectedSpecialPayment.name
            : paymentMethod,
        };
        bluetoothPrinter.printReceipt(printData, posSettings).catch(() => {});
      }
      setCart([]);
      setSelectedCustomer(null);
      setSelectedVehicle(null);
      setPaymentAmount("");
      setDiscountAmount("");
      setDiscountType("flat");
      setVoucherCode("");
      setValidatedVoucher(null);
      setNotes("");
      setShowPaymentModal(false);
      setPaymentMethod("cash");
      setSelectedSpecialPayment(null);
      setRedeemedRules({});
      loadData();
    } catch (error) {
      toast.error(error.response?.data?.message || "Transaksi gagal");
    } finally {
      setLoading(false);
    }
  };

  const handleAddCustomer = async () => {
    if (!newCustomer.name) {
      toast.error("Nama wajib diisi");
      return;
    }
    try {
      const vehicles = newVehicles.filter((v) => {
        if (!v.vehicle_type) return false;
        const vt = vehicleTypes.find((t) => t.name === v.vehicle_type);
        return vt ? !vt.requires_plate || v.plate_number : false;
      });
      const res = await api.post("/customers", { ...newCustomer, vehicles });
      const custRes = await api.get(`/customers/${res.data.id}`);
      const created = custRes.data;
      setCustomers([...customers, created]);
      setSelectedCustomer(created);
      if (created.vehicles?.length > 0) setSelectedVehicle(created.vehicles[0]);
      setShowCustomerModal(false);
      setNewCustomer({ name: "", phone: "" });
      setNewVehicles([{ vehicle_type: "", plate_number: "", brand: "" }]);
      toast.success("Customer ditambahkan");
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Gagal menambahkan customer",
      );
    }
  };

  const handleAddVehicle = async () => {
    if (!newVehicle.vehicle_type) {
      toast.error("Jenis kendaraan wajib diisi");
      return;
    }
    const vt = vehicleTypes.find((t) => t.name === newVehicle.vehicle_type);
    if (vt?.requires_plate && !newVehicle.plate_number) {
      toast.error("Plat nomor wajib diisi");
      return;
    }
    try {
      const addRes = await api.post(
        `/customers/${selectedCustomer.id}/vehicles`,
        newVehicle,
      );
      const vehicleId = addRes.data?.id;
      // Save loyalty progress if applicable
      if (vehicleId) {
        const applicableRules = loyaltyRules.filter((rule) => {
          if (!rule.vehicle_types) return true;
          return rule.vehicle_types
            .split(",")
            .map((s) => s.trim())
            .includes(newVehicle.vehicle_type);
        });
        if (applicableRules.length > 0) {
          const progress = applicableRules.map((rule) => ({
            loyalty_rule_id: rule.id,
            current_count: posLoyaltyProgressEdit[rule.id] ?? 0,
          }));
          await api.put(
            `/customers/${selectedCustomer.id}/vehicles/${vehicleId}/loyalty`,
            { progress },
          );
        }
      }
      const custRes = await api.get(`/customers/${selectedCustomer.id}`);
      const updated = custRes.data;
      setSelectedCustomer(updated);
      setCustomers(customers.map((c) => (c.id === updated.id ? updated : c)));
      const addedVehicle = updated.vehicles?.find(
        (v) =>
          v.plate_number === newVehicle.plate_number &&
          v.vehicle_type === newVehicle.vehicle_type,
      );
      if (addedVehicle) setSelectedVehicle(addedVehicle);
      setShowAddVehicleModal(false);
      setNewVehicle({ vehicle_type: "", plate_number: "", brand: "" });
      setPosLoyaltyProgressEdit({});
      toast.success("Kendaraan ditambahkan");
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Gagal menambahkan kendaraan",
      );
    }
  };

  const fmt = (n) => "Rp " + Number(n).toLocaleString("id-ID");

  // Format tampilan kendaraan: merk + plat nomor (jenis tidak ditampilkan agar ringkas)
  const vehicleLabel = (v) => {
    if (!v) return "";
    const name = v.brand || v.vehicle_type || "";
    return name + (v.plate_number ? ` · ${v.plate_number}` : "");
  };

  // Preview reward yang akan diberikan otomatis (redemption_mode='auto') begitu isi
  // keranjang membawa progress kendaraan mencapai target. Baris ini HANYA tampilan
  // (terkunci): tidak masuk ke `cart` dan tidak dikirim ke server — server yang
  // menambahkannya sendiri saat transaksi disimpan.
  const autoRewardPreviews = (() => {
    if (!loyaltyEnabled) return [];
    const vehicles = selectedCustomer?.vehicles || [];
    if (vehicles.length === 0) return [];
    const previews = [];
    for (const rule of loyaltyRules) {
      if (rule.redemption_mode !== "auto") continue;
      const triggerIds = (rule.trigger_service_ids || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
      const allowedTypes = (rule.vehicle_types || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
      for (const v of vehicles) {
        if (allowedTypes.length > 0 && !allowedTypes.includes(v.vehicle_type))
          continue;
        const triggerQty = cart
          .filter(
            (c) =>
              c.type === "service" &&
              !c.isLoyaltyReward &&
              c.vehicle_id === v.id &&
              triggerIds.includes(String(c.id)),
          )
          .reduce((s, c) => s + c.quantity, 0);
        if (triggerQty <= 0) continue;
        const lp = (v.loyalty_progress || []).find(
          (x) => String(x.rule_id) === String(rule.id),
        );
        const current = lp ? lp.current_count : 0;
        const claims = Math.floor((current + triggerQty) / rule.required_count);
        if (claims <= 0) continue;
        previews.push({
          key: `${rule.id}_${v.id}`,
          ruleName: rule.name,
          rewardName: rule.reward_name,
          vehicleLabel: vehicleLabel(v),
          claims,
        });
      }
    }
    return previews;
  })();

  const handleRedeemLoyalty = () => {
    if (!redeemRuleId || !redeemVehicle) {
      toast.error("Pilih rule loyalti");
      return;
    }
    const rule = loyaltyRules.find((r) => r.id === parseInt(redeemRuleId));
    if (!rule) {
      toast.error("Rule loyalti tidak ditemukan");
      return;
    }
    const lp = (redeemVehicle.loyalty_progress || []).find(
      (x) => String(x.rule_id) === String(redeemRuleId),
    );
    const rewardPrice =
      lp?.reward_service_price != null
        ? Number(lp.reward_service_price)
        : Number(rule.reward_service_price) || 0;

    const key = `${rule.id}_${redeemVehicle.id}`;
    if (redeemedRules[key]) {
      toast.warning("Loyalti ini sudah ada di keranjang");
      setShowRedeemModal(false);
      return;
    }

    // Cek apakah customer memilih upgrade ke service lain
    const upgradeSvc = redeemUpgradeServiceId
      ? services.find((s) => String(s.id) === String(redeemUpgradeServiceId))
      : null;

    setCart((prev) => {
      // Hapus item yang dipilih sebelumnya jika memang dari alur addToCart
      const base = redeemReplaceItem
        ? prev.filter(
            (c) =>
              !(
                c.id === redeemReplaceItem.id &&
                c.type === redeemReplaceItem.type &&
                c.vehicle_id === redeemReplaceItem.vehicle_id &&
                !c.isLoyaltyReward
              ),
          )
        : prev;

      if (upgradeSvc) {
        // Upgrade: tambahkan service yang lebih mahal dengan loyaltyDiscountAmount = rewardPrice
        return [
          ...base,
          {
            id: upgradeSvc.id,
            type: "service",
            name: `${upgradeSvc.name} 🎁`,
            price: upgradeSvc.price,
            quantity: 1,
            maxStock: 1,
            discount: 0,
            vehicle_id: redeemVehicle.id,
            vehicle_label: vehicleLabel(redeemVehicle),
            category_name: upgradeSvc.category_name || "",
            isLoyaltyReward: true,
            loyaltyRuleId: rule.id,
            loyaltyDiscountAmount: rewardPrice,
          },
        ];
      }

      // Ambil gratis: service reward dengan diskon penuh
      return [
        ...base,
        {
          id: rule.reward_service_id,
          type: "service",
          name: `${rule.reward_service_name} 🎁`,
          price: rewardPrice,
          quantity: 1,
          maxStock: 1,
          discount: 0,
          vehicle_id: redeemVehicle.id,
          vehicle_label: vehicleLabel(redeemVehicle),
          category_name: "",
          isLoyaltyReward: true,
          loyaltyRuleId: rule.id,
        },
      ];
    });

    if (upgradeSvc) {
      toast.success(
        `🎁 Upgrade ke ${upgradeSvc.name} — diskon loyalty ${fmt(rewardPrice)}!`,
      );
    } else {
      toast.success(
        `🎁 ${rule.reward_service_name} ditambahkan sebagai hadiah loyalty!`,
      );
    }

    setRedeemedRules((prev) => ({ ...prev, [key]: true }));
    setShowRedeemModal(false);
    setRedeemRuleId("");
    setRedeemVehicle(null);
    setRedeemReplaceItem(null);
    setRedeemUpgradeServiceId(null);
  };

  // Filtered items
  const servicesCats = [
    ...new Set(services.map((s) => s.category_name).filter(Boolean)),
  ];
  const productsCats = [
    ...new Set(products.map((p) => p.category_name).filter(Boolean)),
  ];
  const filteredServices = services.filter(
    (s) =>
      s.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (serviceFilter === "all" || s.category_name === serviceFilter),
  );
  const filteredProducts = products.filter(
    (p) =>
      p.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (productFilter === "all" || p.category_name === productFilter),
  );
  const filteredCustomers = customers.filter(
    (c) =>
      c.name.toLowerCase().includes(customerSearch.toLowerCase()) ||
      (c.phone || "").includes(customerSearch) ||
      (c.vehicles || []).some((v) =>
        vehicleLabel(v).toLowerCase().includes(customerSearch.toLowerCase()),
      ),
  );

  const paymentIcons = {
    cash: <FiDollarSign />,
    debit: <FiCreditCard />,
    credit: <FiCreditCard />,
    qris: <span style={{ fontSize: "0.8em" }}>QR</span>,
    transfer: <span style={{ fontSize: "0.8em" }}>TF</span>,
  };

  return (
    <div className="pos-container">
      {/* Shift Opening Modal - mandatory for kasir */}
      <Modal show={showShiftModal} backdrop="static" keyboard={false} centered>
        <Modal.Header>
          <Modal.Title>
            {staleShift ? "⚠️ Shift Belum Ditutup" : "Buka Shift"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {staleShift ? (
            <>
              <div className="alert alert-warning mb-3">
                <strong>
                  Shift tanggal{" "}
                  {parseWIB(staleShift.start_time).toLocaleDateString("id-ID", {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}{" "}
                  masih terbuka.
                </strong>
                <br />
                Pilih tindakan yang ingin dilakukan:
              </div>
              <div className="d-grid gap-2">
                <Button variant="success" onClick={handleContinueShift}>
                  ✅ Lanjutkan Shift Ini
                </Button>
                <Button
                  variant="outline-warning"
                  onClick={async () => {
                    await handleCloseStaleShift();
                  }}
                >
                  🔄 Tutup Shift &amp; Buka Shift Baru
                </Button>
              </div>
              <p className="text-muted small mt-2 mb-0">
                Jika tutup shift, kas akhir akan tercatat Rp 0 (bisa diubah di
                halaman Manajemen Shift).
              </p>
            </>
          ) : (
            <>
              <p className="text-muted mb-3">
                Anda harus membuka shift terlebih dahulu sebelum menggunakan
                kasir. Masukkan jumlah kas awal (uang modal) di meja kasir.
              </p>
              <Form.Group>
                <Form.Label>Kas Awal (Rp)</Form.Label>
                <Form.Control
                  type="number"
                  min="0"
                  value={shiftOpeningCash}
                  onChange={(e) => setShiftOpeningCash(e.target.value)}
                  placeholder="Masukkan jumlah kas awal..."
                  autoFocus
                  onKeyDown={(e) => e.key === "Enter" && handleOpenShift()}
                />
              </Form.Group>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {!staleShift && (
            <Button variant="success" onClick={handleOpenShift}>
              Buka Shift
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {!shiftReady ? (
        <div className="text-center py-5">
          <FiClock size={48} className="text-muted mb-3" />
          <h5 className="text-muted">Menunggu shift dibuka...</h5>
        </div>
      ) : (
        <>
          {/* ===== LEFT: CATALOG ===== */}
          <div className="pos-items">
            {/* Customer & Vehicle Bar */}
            <div className="pos-customer-bar">
              {selectedCustomer ? (
                <div className="pos-customer-selected">
                  <div
                    className="pos-customer-info"
                    onClick={() => setShowCustomerPicker(true)}
                  >
                    <div className="pos-customer-avatar">
                      {selectedCustomer.name.charAt(0).toUpperCase()}
                    </div>
                    <div>
                      <div className="pos-customer-name">
                        {selectedCustomer.name}
                      </div>
                      <div className="pos-customer-meta">
                        {selectedCustomer.phone || "No HP belum diisi"}
                      </div>
                    </div>
                  </div>
                  <button
                    className="btn btn-sm btn-link text-danger"
                    onClick={() => {
                      setSelectedCustomer(null);
                      setSelectedVehicle(null);
                    }}
                  >
                    <FiTrash2 />
                  </button>
                </div>
              ) : (
                <button
                  className="pos-customer-placeholder"
                  onClick={() => setShowCustomerPicker(true)}
                >
                  <FiUser className="me-2" /> Pilih Customer (opsional)
                </button>
              )}

              {/* Vehicle chips */}
              {selectedCustomer && (
                <div className="pos-vehicle-chips">
                  {(selectedCustomer.vehicles || []).map((v) => (
                    <button
                      key={v.id}
                      className={`pos-vehicle-chip ${selectedVehicle?.id === v.id ? "active" : ""}`}
                      onClick={() => {
                        const next = selectedVehicle?.id === v.id ? null : v;
                        setSelectedVehicle(next);
                        setServiceFilter(next?.top_category_name || "all");
                        setActiveTab("services");
                      }}
                    >
                      <FiTruck size={12} />
                      <span>{vehicleLabel(v)}</span>
                      {v.top_category_name && (
                        <span className="pos-vehicle-category">
                          {v.top_category_name}
                        </span>
                      )}
                      {loyaltyEnabled &&
                        (v.loyalty_progress || []).length > 0 && (
                          <span className="pos-vehicle-brand">
                            (
                            {v.loyalty_progress
                              .map(
                                (lp) =>
                                  `${lp.current_count}/${lp.required_count}`,
                              )
                              .join(", ")}
                            )
                          </span>
                        )}
                    </button>
                  ))}
                  <button
                    className="pos-vehicle-chip"
                    onClick={() => setShowAddVehicleModal(true)}
                    title="Tambah Kendaraan"
                  >
                    <FiPlus size={12} /> Tambah
                  </button>
                </div>
              )}
              {selectedCustomer &&
                (selectedCustomer.vehicles || []).some(
                  (v) => v.top_category_name,
                ) && (
                  <div
                    className="alert alert-info py-1 px-2 mb-0 mt-1"
                    style={{ fontSize: "0.7rem" }}
                  >
                    Label biru di samping plat nomor menunjukkan kategori
                    layanan yang biasa digunakan kendaraan ini
                  </div>
                )}

              {/* Loyalty Progress */}
              {selectedCustomer &&
                loyaltyEnabled &&
                (selectedCustomer.vehicles || []).length > 0 && (
                  <div className="pos-loyalty-bar">
                    {(selectedCustomer.vehicles || []).map((v) => {
                      const progress = v.loyalty_progress || [];
                      if (progress.length === 0) return null;
                      return progress.map((lp) => {
                        const pct = Math.min(
                          100,
                          (lp.current_count / lp.required_count) * 100,
                        );
                        const isAuto = lp.redemption_mode === "auto";
                        const canRedeem =
                          !isAuto && lp.current_count >= lp.required_count;
                        return (
                          <div
                            key={`${v.id}-${lp.rule_id}`}
                            className={`pos-loyalty-item ${canRedeem ? "redeemable" : ""}`}
                          >
                            <div className="pos-loyalty-info">
                              <span className="pos-loyalty-label">
                                {vehicleLabel(v)} · {lp.rule_name}
                              </span>
                              <span className="pos-loyalty-count">
                                {lp.current_count}/{lp.required_count}
                                {isAuto && (
                                  <Badge
                                    bg="primary"
                                    style={{ fontSize: "0.55rem", marginLeft: 4 }}
                                  >
                                    Auto
                                  </Badge>
                                )}
                              </span>
                            </div>
                            <div className="pos-loyalty-progress">
                              <div style={{ width: `${pct}%` }}></div>
                            </div>
                            {canRedeem && (
                              <button
                                className={`pos-loyalty-redeem${
                                  redeemedRules[`${lp.rule_id}_${v.id}`]
                                    ? " disabled"
                                    : ""
                                }`}
                                disabled={
                                  !!redeemedRules[`${lp.rule_id}_${v.id}`]
                                }
                                onClick={() => {
                                  if (redeemedRules[`${lp.rule_id}_${v.id}`])
                                    return;
                                  setRedeemVehicle(v);
                                  setRedeemRuleId(String(lp.rule_id));
                                  setShowRedeemModal(true);
                                }}
                              >
                                <FiGift size={12} />{" "}
                                {redeemedRules[`${lp.rule_id}_${v.id}`]
                                  ? "Di keranjang"
                                  : "Redeem"}
                              </button>
                            )}
                          </div>
                        );
                      });
                    })}
                  </div>
                )}
            </div>

            {/* Search + Category Filter */}
            <div className="pos-search-bar">
              <div className="pos-search-input">
                <FiSearch className="pos-search-icon" />
                <input
                  type="text"
                  placeholder="Cari layanan atau produk..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                {searchTerm && (
                  <button
                    className="pos-search-clear"
                    onClick={() => setSearchTerm("")}
                  >
                    &times;
                  </button>
                )}
              </div>
            </div>

            {/* Tabs & Items */}
            <div className="pos-tabs">
              <button
                className={`pos-tab ${activeTab === "services" ? "active" : ""}`}
                onClick={() => setActiveTab("services")}
              >
                <FiClock size={14} /> Layanan{" "}
                <span className="pos-tab-count">{filteredServices.length}</span>
              </button>
              <button
                className={`pos-tab ${activeTab === "products" ? "active" : ""}`}
                onClick={() => setActiveTab("products")}
              >
                <FiShoppingCart size={14} /> Produk{" "}
                <span className="pos-tab-count">{filteredProducts.length}</span>
              </button>
            </div>

            {/* Category Chips */}
            {activeTab === "services" && servicesCats.length > 1 && (
              <div className="pos-category-chips">
                <button
                  className={`pos-cat-chip ${serviceFilter === "all" ? "active" : ""}`}
                  onClick={() => setServiceFilter("all")}
                >
                  Semua
                </button>
                {servicesCats.map((cat) => (
                  <button
                    key={cat}
                    className={`pos-cat-chip ${serviceFilter === cat ? "active" : ""}`}
                    onClick={() => setServiceFilter(cat)}
                  >
                    {cat}
                  </button>
                ))}
              </div>
            )}
            {activeTab === "products" && productsCats.length > 1 && (
              <div className="pos-category-chips">
                <button
                  className={`pos-cat-chip ${productFilter === "all" ? "active" : ""}`}
                  onClick={() => setProductFilter("all")}
                >
                  Semua
                </button>
                {productsCats.map((cat) => (
                  <button
                    key={cat}
                    className={`pos-cat-chip ${productFilter === cat ? "active" : ""}`}
                    onClick={() => setProductFilter(cat)}
                  >
                    {cat}
                  </button>
                ))}
              </div>
            )}

            {/* Item Grid */}
            <div className="pos-item-grid">
              {activeTab === "services" ? (
                filteredServices.length > 0 ? (
                  filteredServices.map((svc) => (
                    <div
                      key={svc.id}
                      className="pos-item-card pos-item-service"
                      onClick={() => addToCart(svc, "service")}
                    >
                      <div className="pos-item-category">
                        {svc.category_name}
                      </div>
                      <div className="pos-item-name">{svc.name}</div>
                      <div className="pos-item-price">{fmt(svc.price)}</div>
                      <div className="pos-item-meta">
                        <FiClock size={11} /> {svc.duration_minutes} menit
                      </div>
                      {cart.some(
                        (c) => c.id === svc.id && c.type === "service",
                      ) && (
                        <div className="pos-item-in-cart">
                          {cart
                            .filter(
                              (c) => c.id === svc.id && c.type === "service",
                            )
                            .reduce((s, c) => s + c.quantity, 0)}
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <div className="pos-empty">Tidak ada layanan ditemukan</div>
                )
              ) : filteredProducts.length > 0 ? (
                filteredProducts.map((prod) => (
                  <div
                    key={prod.id}
                    className={`pos-item-card pos-item-product ${prod.stock <= 0 ? "out-of-stock" : ""}`}
                    onClick={() => prod.stock > 0 && addToCart(prod, "product")}
                  >
                    <div className="pos-item-category">
                      {prod.category_name}
                    </div>
                    <div className="pos-item-name">{prod.name}</div>
                    <div className="pos-item-price">{fmt(prod.sell_price)}</div>
                    <div className="pos-item-meta">
                      {prod.stock > 0 ? (
                        `Stok: ${prod.stock} ${prod.unit}`
                      ) : (
                        <span className="text-danger">Habis</span>
                      )}
                    </div>
                    {cart.some(
                      (c) => c.id === prod.id && c.type === "product",
                    ) && (
                      <div className="pos-item-in-cart">
                        {cart
                          .filter(
                            (c) => c.id === prod.id && c.type === "product",
                          )
                          .reduce((s, c) => s + c.quantity, 0)}
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <div className="pos-empty">Tidak ada produk ditemukan</div>
              )}
            </div>
          </div>

          {/* ===== RIGHT: CART ===== */}
          <div className="pos-cart">
            <div className="pos-cart-header">
              <h6 className="mb-0">
                <FiShoppingCart className="me-2" />
                Keranjang
                {totalItems > 0 && (
                  <Badge bg="primary" pill className="ms-2">
                    {totalItems}
                  </Badge>
                )}
              </h6>
            </div>

            <div className="cart-items">
              {cart.length === 0 ? (
                <div className="pos-cart-empty">
                  <FiShoppingCart size={40} />
                  <p>Keranjang kosong</p>
                  <small>Klik layanan atau produk untuk menambahkan</small>
                </div>
              ) : (
                cart.map((item, index) => (
                  <div key={index} className="pos-cart-item">
                    <div className="pos-cart-item-top">
                      <div className="pos-cart-item-info">
                        <Badge
                          bg={
                            item.isLoyaltyReward
                              ? "warning"
                              : item.type === "service"
                                ? "info"
                                : "success"
                          }
                          text={item.isLoyaltyReward ? "dark" : undefined}
                          style={{ fontSize: "0.6rem" }}
                        >
                          {item.isLoyaltyReward
                            ? item.loyaltyDiscountAmount != null
                              ? "🎁 UPGRADE"
                              : "🎁 GRATIS"
                            : item.type === "service"
                              ? "JASA"
                              : "PRODUK"}
                        </Badge>
                        <span className="pos-cart-item-name">{item.name}</span>
                      </div>
                      <button
                        className="pos-cart-item-remove"
                        onClick={() => removeFromCart(index)}
                      >
                        <FiTrash2 size={13} />
                      </button>
                    </div>
                    {/* Vehicle selector */}
                    {item.type === "service" &&
                      selectedCustomer &&
                      (selectedCustomer.vehicles || []).length > 0 && (
                        <select
                          className="pos-cart-vehicle-select"
                          value={item.vehicle_id || ""}
                          disabled={!!item.isLoyaltyReward}
                          title={
                            item.isLoyaltyReward
                              ? "Kendaraan tidak bisa diubah untuk hadiah loyalty"
                              : undefined
                          }
                          onChange={(e) => {
                            const vId = e.target.value
                              ? parseInt(e.target.value)
                              : null;
                            const v = (selectedCustomer.vehicles || []).find(
                              (v) => v.id === vId,
                            );
                            const nc = [...cart];
                            nc[index] = {
                              ...nc[index],
                              vehicle_id: vId,
                              vehicle_label: v ? vehicleLabel(v) : null,
                            };
                            setCart(nc);
                          }}
                        >
                          <option value="">Tanpa kendaraan</option>
                          {(selectedCustomer.vehicles || []).map((v) => (
                            <option key={v.id} value={v.id}>
                              {vehicleLabel(v)}
                            </option>
                          ))}
                        </select>
                      )}
                    <div className="pos-cart-item-bottom">
                      <div className="pos-cart-qty">
                        <button onClick={() => updateQuantity(index, -1)}>
                          <FiMinus size={12} />
                        </button>
                        <span>{item.quantity}</span>
                        <button
                          onClick={() => updateQuantity(index, 1)}
                          disabled={!!item.isLoyaltyReward}
                          style={
                            item.isLoyaltyReward
                              ? { opacity: 0.3, cursor: "not-allowed" }
                              : {}
                          }
                        >
                          <FiPlus size={12} />
                        </button>
                      </div>
                      <div className="pos-cart-item-subtotal">
                        {item.isLoyaltyReward ? (
                          item.loyaltyDiscountAmount != null ? (
                            <span>
                              <span
                                style={{
                                  textDecoration: "line-through",
                                  color: "#94a3b8",
                                  fontSize: "0.8em",
                                  marginRight: 4,
                                }}
                              >
                                {fmt(item.price)}
                              </span>
                              <span className="text-warning fw-bold">
                                {fmt(
                                  (item.price - item.loyaltyDiscountAmount) *
                                    item.quantity,
                                )}
                              </span>
                            </span>
                          ) : (
                            <span>
                              <span
                                style={{
                                  textDecoration: "line-through",
                                  color: "#94a3b8",
                                  fontSize: "0.8em",
                                  marginRight: 4,
                                }}
                              >
                                {fmt(item.price)}
                              </span>
                              <span className="text-success fw-bold">
                                GRATIS
                              </span>
                            </span>
                          )
                        ) : (
                          fmt(item.price * item.quantity)
                        )}
                      </div>
                    </div>
                  </div>
                ))
              )}

              {/* Preview reward otomatis (terkunci, tidak bisa dihapus) */}
              {autoRewardPreviews.map((p) => (
                <div
                  key={`auto-${p.key}`}
                  className="pos-cart-item"
                  style={{ borderLeft: "3px solid #f59e0b" }}
                >
                  <div className="pos-cart-item-top">
                    <div className="pos-cart-item-info">
                      <Badge
                        bg="warning"
                        text="dark"
                        style={{ fontSize: "0.6rem" }}
                      >
                        🎁 GRATIS
                      </Badge>
                      <span className="pos-cart-item-name">
                        {p.rewardName}
                        {p.claims > 1 ? ` ×${p.claims}` : ""} 🔒
                      </span>
                    </div>
                  </div>
                  <div className="pos-cart-item-bottom">
                    <small className="text-muted">
                      Otomatis · {p.vehicleLabel} · {p.ruleName}
                    </small>
                    <div className="pos-cart-item-subtotal">
                      <span className="text-success fw-bold">GRATIS</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Cart Footer */}
            <div className="cart-footer">
              {cart.length > 0 && (
                <>
                  <div className="pos-cart-summary">
                    <div className="pos-cart-summary-row">
                      <span>Subtotal ({totalItems} item)</span>
                      <span>{fmt(subtotal)}</span>
                    </div>
                    {totalDiscount > 0 && (
                      <div className="pos-cart-summary-row text-danger">
                        <span>Diskon</span>
                        <span>-{fmt(totalDiscount)}</span>
                      </div>
                    )}
                    {loyaltyRewardDiscount > 0 && (
                      <div className="pos-cart-summary-row text-success">
                        <span>🎁 Hadiah Loyalty (gratis)</span>
                        <span>-{fmt(loyaltyRewardDiscount)}</span>
                      </div>
                    )}
                    <div className="pos-cart-summary-total">
                      <span>Total</span>
                      <span>{fmt(total)}</span>
                    </div>
                  </div>
                  <button
                    className="pos-pay-btn"
                    disabled={cart.length === 0}
                    onClick={openPayOrWarn}
                  >
                    <FiSend /> Bayar {fmt(total)}
                  </button>
                </>
              )}
            </div>
          </div>

          {/* ===== CUSTOMER PICKER MODAL ===== */}
          <Modal
            show={showCustomerPicker}
            onHide={() => setShowCustomerPicker(false)}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Pilih Customer</Modal.Title>
            </Modal.Header>
            <Modal.Body
              style={{
                padding: 0,
                maxHeight: "60vh",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  padding: "12px 16px",
                  borderBottom: "1px solid #e2e8f0",
                }}
              >
                <div className="pos-search-input" style={{ marginBottom: 0 }}>
                  <FiSearch className="pos-search-icon" />
                  <input
                    type="text"
                    placeholder="Cari nama, HP, atau plat..."
                    value={customerSearch}
                    onChange={(e) => setCustomerSearch(e.target.value)}
                    autoFocus
                  />
                </div>
              </div>
              <div style={{ overflow: "auto", flex: 1 }}>
                {filteredCustomers.map((c) => (
                  <div
                    key={c.id}
                    className="pos-customer-option"
                    onClick={() => {
                      setSelectedCustomer(c);
                      setSelectedVehicle(
                        c.vehicles?.length === 1 ? c.vehicles[0] : null,
                      );
                      setShowCustomerPicker(false);
                      setCustomerSearch("");
                    }}
                  >
                    <div
                      className="pos-customer-avatar"
                      style={{ width: 36, height: 36, fontSize: "0.85rem" }}
                    >
                      {c.name.charAt(0).toUpperCase()}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div className="fw-bold small">{c.name}</div>
                      <div
                        className="text-muted"
                        style={{ fontSize: "0.75rem" }}
                      >
                        {c.phone || "-"} · {(c.vehicles || []).length} kendaraan
                        {(c.vehicles || []).length > 0 &&
                          ` · ${(c.vehicles || []).map((v) => vehicleLabel(v)).join(", ")}`}
                      </div>
                    </div>
                  </div>
                ))}
                {filteredCustomers.length === 0 && (
                  <div className="text-center py-4 text-muted small">
                    Tidak ditemukan
                  </div>
                )}
              </div>
              <div
                style={{ padding: "12px 16px", borderTop: "1px solid #e2e8f0" }}
              >
                <Button
                  variant="outline-primary"
                  className="w-100"
                  onClick={() => {
                    setShowCustomerPicker(false);
                    setShowCustomerModal(true);
                  }}
                >
                  <FiPlus className="me-1" /> Tambah Customer Baru
                </Button>
              </div>
            </Modal.Body>
          </Modal>

          {/* ===== PAYMENT MODAL ===== */}
          <Modal
            show={showPaymentModal}
            onHide={() => setShowPaymentModal(false)}
            centered
            size="md"
          >
            <Modal.Body style={{ padding: "24px" }}>
              <div className="pos-payment-total">
                <small>Total Pembayaran</small>
                <div className="pos-payment-amount">{fmt(total)}</div>
                {selectedSpecialPayment && (
                  <small className="text-success d-block mt-1">
                    Override: {selectedSpecialPayment.name}
                  </small>
                )}
              </div>

              <div className="pos-payment-methods mb-3">
                {Object.entries({
                  cash: "Cash",
                  debit: "Debit/Credit",
                  qris: "QRIS",
                  transfer: "Transfer",
                }).map(([k, v]) => (
                  <button
                    key={k}
                    className={`pos-pm-btn ${paymentMethod === k && !selectedSpecialPayment ? "active" : ""}`}
                    onClick={() => {
                      setPaymentMethod(k);
                      setSelectedSpecialPayment(null);
                    }}
                  >
                    {paymentIcons[k]} {v}
                  </button>
                ))}
                <button
                  className={`pos-pm-btn unpaid ${paymentMethod === "unpaid" && !selectedSpecialPayment ? "active" : ""}`}
                  onClick={() => {
                    setPaymentMethod("unpaid");
                    setSelectedSpecialPayment(null);
                  }}
                >
                  <FiClock /> Nanti
                </button>
                {specialPaymentMethods.map((pm) => (
                  <button
                    key={`spm-${pm.id}`}
                    className={`pos-pm-btn ${selectedSpecialPayment?.id === pm.id ? "active" : ""}`}
                    onClick={() => {
                      setSelectedSpecialPayment(pm);
                      setPaymentMethod("special");
                    }}
                    title={
                      pm.override_price != null
                        ? `Override: ${fmt(pm.override_price)}/layanan`
                        : pm.name
                    }
                  >
                    <FiDollarSign /> {pm.name}
                  </button>
                ))}
              </div>

              {paymentMethod === "unpaid" && !selectedSpecialPayment && (
                <div className="alert alert-warning py-2 small mb-3">
                  Transaksi disimpan tanpa pembayaran. Bisa dibayar nanti dari
                  halaman Transaksi.
                </div>
              )}

              {(!selectedSpecialPayment ||
                selectedSpecialPayment?.override_price == null) && (
                <details className="pos-payment-extras mb-3">
                  <summary>Diskon & Voucher</summary>
                  <div className="pt-2">
                    <div className="row g-2 mb-2">
                      <div className="col-6">
                        <label className="form-label small">
                          Diskon Manual
                        </label>
                        <div className="input-group input-group-sm">
                          <select
                            className="form-select"
                            style={{ maxWidth: "70px" }}
                            value={discountType}
                            onChange={(e) => setDiscountType(e.target.value)}
                          >
                            <option value="flat">Rp</option>
                            <option value="percentage">%</option>
                          </select>
                          <input
                            type="number"
                            className="form-control"
                            value={discountAmount}
                            onChange={(e) => setDiscountAmount(e.target.value)}
                            placeholder="0"
                            min="0"
                            max={
                              discountType === "percentage" ? 100 : undefined
                            }
                          />
                        </div>
                        {discountAmount > 0 && (
                          <div className="small text-muted mt-1">
                            = {fmt(manualDiscount)}
                          </div>
                        )}
                      </div>
                      <div className="col-6">
                        <label className="form-label small">Kode Voucher</label>
                        <div className="input-group input-group-sm">
                          <input
                            type="text"
                            className="form-control"
                            value={voucherCode}
                            onChange={(e) => setVoucherCode(e.target.value)}
                            placeholder="Kode"
                          />
                          <button
                            className="btn btn-outline-primary"
                            onClick={validateVoucher}
                          >
                            Cek
                          </button>
                        </div>
                        {validatedVoucher && (
                          <div className="small text-success mt-1">
                            ✓{" "}
                            {validatedVoucher.discount_type === "percentage"
                              ? `${validatedVoucher.discount_value}%`
                              : fmt(validatedVoucher.discount_value)}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </details>
              )}

              {paymentMethod === "cash" && !selectedSpecialPayment && (
                <div className="mb-3">
                  <label className="form-label small fw-bold">
                    Jumlah Bayar
                  </label>
                  <input
                    type="number"
                    className="form-control form-control-lg text-center"
                    value={paymentAmount}
                    onChange={(e) => setPaymentAmount(e.target.value)}
                    placeholder="0"
                    autoFocus
                  />
                  <div className="pos-quick-amounts">
                    {(() => {
                      const steps = [
                        1000, 5000, 10000, 20000, 50000, 100000, 200000, 500000,
                        1000000,
                      ];
                      const amounts = [
                        ...new Set(steps.map((s) => Math.ceil(total / s) * s)),
                      ]
                        .filter((v) => v >= total)
                        .slice(0, 5);
                      return amounts.map((amt) => (
                        <button
                          key={amt}
                          onClick={() => setPaymentAmount(amt.toString())}
                        >
                          {fmt(amt)}
                        </button>
                      ));
                    })()}
                  </div>
                  {Number(paymentAmount) >= total && (
                    <div className="pos-change">
                      Kembalian:{" "}
                      <strong>{fmt(Number(paymentAmount) - total)}</strong>
                    </div>
                  )}
                </div>
              )}

              <div className="mb-2">
                <label className="form-label small">Catatan</label>
                <textarea
                  className="form-control form-control-sm"
                  rows="2"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  placeholder="Opsional..."
                />
              </div>
            </Modal.Body>
            <Modal.Footer style={{ border: "none", padding: "0 24px 24px" }}>
              <Button
                variant="light"
                onClick={() => setShowPaymentModal(false)}
                style={{ flex: 1 }}
              >
                Batal
              </Button>
              <Button
                variant={
                  paymentMethod === "unpaid" && !selectedSpecialPayment
                    ? "warning"
                    : "primary"
                }
                onClick={handleCheckout}
                disabled={loading}
                style={{ flex: 2 }}
              >
                {loading
                  ? "Memproses..."
                  : paymentMethod === "unpaid" && !selectedSpecialPayment
                    ? "Simpan (Bayar Nanti)"
                    : `Bayar ${fmt(total)}`}
              </Button>
            </Modal.Footer>
          </Modal>

          {/* ===== NEW CUSTOMER MODAL ===== */}
          <Modal
            show={showCustomerModal}
            onHide={() => setShowCustomerModal(false)}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Customer Baru</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row g-2 mb-3">
                <div className="col-6">
                  <Form.Label className="small">Nama *</Form.Label>
                  <Form.Control
                    value={newCustomer.name}
                    onChange={(e) =>
                      setNewCustomer({ ...newCustomer, name: e.target.value })
                    }
                  />
                </div>
                <div className="col-6">
                  <Form.Label className="small">No. HP</Form.Label>
                  <Form.Control
                    value={newCustomer.phone}
                    onChange={(e) =>
                      setNewCustomer({ ...newCustomer, phone: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="fw-bold small">Kendaraan</span>
                <Button
                  size="sm"
                  variant="outline-primary"
                  onClick={() =>
                    setNewVehicles([
                      ...newVehicles,
                      { vehicle_type: "", plate_number: "", brand: "" },
                    ])
                  }
                >
                  <FiPlus size={12} /> Tambah
                </Button>
              </div>
              {newVehicles.map((v, i) => (
                <div key={i} className="d-flex gap-2 mb-2 align-items-center">
                  <Form.Select
                    size="sm"
                    style={{ flex: 1 }}
                    value={v.vehicle_type}
                    onChange={(e) => {
                      const nv = [...newVehicles];
                      nv[i].vehicle_type = e.target.value;
                      setNewVehicles(nv);
                    }}
                  >
                    <option value="">Jenis</option>
                    {vehicleTypes.map((vt) => (
                      <option key={vt.id} value={vt.name}>
                        {vt.name}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control
                    size="sm"
                    style={{ flex: 1 }}
                    placeholder="Plat Nomor"
                    value={v.plate_number}
                    onChange={(e) => {
                      const nv = [...newVehicles];
                      nv[i].plate_number = e.target.value.toUpperCase();
                      setNewVehicles(nv);
                    }}
                    onBlur={(e) => {
                      const nv = [...newVehicles];
                      nv[i].plate_number = formatPlate(e.target.value);
                      setNewVehicles(nv);
                    }}
                  />
                  <Form.Control
                    size="sm"
                    style={{ flex: 1 }}
                    placeholder="Merk (Honda Civic, dll)"
                    value={v.brand || ""}
                    onChange={(e) => {
                      const nv = [...newVehicles];
                      nv[i].brand = e.target.value;
                      setNewVehicles(nv);
                    }}
                  />
                  {newVehicles.length > 1 && (
                    <Button
                      size="sm"
                      variant="link"
                      className="text-danger p-0"
                      onClick={() =>
                        setNewVehicles(
                          newVehicles.filter((_, idx) => idx !== i),
                        )
                      }
                    >
                      <FiTrash2 size={14} />
                    </Button>
                  )}
                </div>
              ))}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="light"
                onClick={() => setShowCustomerModal(false)}
              >
                Batal
              </Button>
              <Button variant="primary" onClick={handleAddCustomer}>
                Simpan
              </Button>
            </Modal.Footer>
          </Modal>

          {/* ===== ADD VEHICLE MODAL ===== */}
          <Modal
            show={showAddVehicleModal}
            onHide={() => {
              setShowAddVehicleModal(false);
              setPosLoyaltyProgressEdit({});
            }}
            centered
            size="sm"
          >
            <Modal.Header closeButton>
              <Modal.Title>Tambah Kendaraan</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p className="text-muted small mb-3">
                Tambah kendaraan untuk <strong>{selectedCustomer?.name}</strong>
              </p>
              <Form.Group className="mb-2">
                <Form.Label className="small">Jenis Kendaraan *</Form.Label>
                <Form.Select
                  size="sm"
                  value={newVehicle.vehicle_type}
                  onChange={(e) =>
                    setNewVehicle({
                      ...newVehicle,
                      vehicle_type: e.target.value,
                    })
                  }
                >
                  <option value="">Pilih jenis</option>
                  {vehicleTypes.map((vt) => (
                    <option key={vt.id} value={vt.name}>
                      {vt.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label className="small">Plat Nomor</Form.Label>
                <Form.Control
                  size="sm"
                  placeholder="Contoh: B 1234 ABC"
                  value={newVehicle.plate_number}
                  onChange={(e) =>
                    setNewVehicle({
                      ...newVehicle,
                      plate_number: e.target.value.toUpperCase(),
                    })
                  }
                  onBlur={(e) =>
                    setNewVehicle({
                      ...newVehicle,
                      plate_number: formatPlate(e.target.value),
                    })
                  }
                />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label className="small">Merk</Form.Label>
                <Form.Control
                  size="sm"
                  placeholder="Contoh: Honda Civic"
                  value={newVehicle.brand}
                  onChange={(e) =>
                    setNewVehicle({ ...newVehicle, brand: e.target.value })
                  }
                />
              </Form.Group>
              {/* Loyalty Progress */}
              {loyaltyEnabled &&
                (() => {
                  const applicable = loyaltyRules.filter((rule) => {
                    if (!newVehicle.vehicle_type) return false;
                    if (!rule.vehicle_types) return true;
                    return rule.vehicle_types
                      .split(",")
                      .map((s) => s.trim())
                      .includes(newVehicle.vehicle_type);
                  });
                  if (!applicable.length) return null;
                  return (
                    <div className="mt-3 border-top pt-2">
                      <div className="small fw-semibold text-muted mb-2">
                        Progress Loyalti
                      </div>
                      {applicable.map((rule) => (
                        <Form.Group className="mb-2" key={rule.id}>
                          <Form.Label className="small">
                            {rule.name}{" "}
                            <span className="text-muted">
                              ({posLoyaltyProgressEdit[rule.id] ?? 0}/
                              {rule.required_count}x)
                            </span>
                          </Form.Label>
                          <Form.Control
                            type="number"
                            size="sm"
                            min={0}
                            max={rule.required_count}
                            value={posLoyaltyProgressEdit[rule.id] ?? 0}
                            onChange={(e) =>
                              setPosLoyaltyProgressEdit({
                                ...posLoyaltyProgressEdit,
                                [rule.id]: Math.max(
                                  0,
                                  Math.min(
                                    rule.required_count,
                                    Number(e.target.value),
                                  ),
                                ),
                              })
                            }
                          />
                        </Form.Group>
                      ))}
                    </div>
                  );
                })()}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="light"
                onClick={() => setShowAddVehicleModal(false)}
              >
                Batal
              </Button>
              <Button variant="primary" onClick={handleAddVehicle}>
                Simpan
              </Button>
            </Modal.Footer>
          </Modal>

          {/* ===== REDEEM LOYALTY MODAL ===== */}
          <Modal
            show={showRedeemModal}
            onHide={() => {
              setShowRedeemModal(false);
              setRedeemRuleId("");
              setRedeemVehicle(null);
              setRedeemReplaceItem(null);
              setRedeemUpgradeServiceId(null);
            }}
            centered
          >
            <Modal.Body className="text-center p-4">
              <div style={{ fontSize: "3rem", marginBottom: "8px" }}>🎉</div>
              <h5 className="text-success mb-1">Klaim Hadiah Loyalty!</h5>
              <p className="text-muted small mb-3">
                {selectedCustomer?.name} — {vehicleLabel(redeemVehicle)}
              </p>
              {(() => {
                if (!redeemVehicle) return null;
                const lp = (redeemVehicle.loyalty_progress || []).find(
                  (x) => String(x.rule_id) === String(redeemRuleId),
                );
                const rule = loyaltyRules.find(
                  (r) => r.id === parseInt(redeemRuleId),
                );
                if (!rule) return null;
                const rewardPrice =
                  Number(lp?.reward_service_price) ||
                  Number(rule.reward_service_price) ||
                  0;

                const upgradeOptions = services
                  .filter(
                    (s) =>
                      s.price > rewardPrice &&
                      String(s.category_id) ===
                        String(rule.reward_service_category_id),
                  )
                  .sort((a, b) => a.price - b.price);

                const selectedUpgrade = redeemUpgradeServiceId
                  ? upgradeOptions.find(
                      (s) => String(s.id) === String(redeemUpgradeServiceId),
                    )
                  : null;

                return (
                  <>
                    <div className="alert alert-success text-start py-2 small mb-3">
                      <strong>{rule.name}</strong>
                      <br />
                      Hadiah: {rule.reward_service_name}
                      {rewardPrice > 0 ? ` (${fmt(rewardPrice)})` : ""}
                      <br />
                      Progress: {lp?.current_count}/{lp?.required_count}
                    </div>

                    {upgradeOptions.length > 0 && (
                      <div className="text-start mb-3">
                        <Form.Label className="small fw-semibold mb-1">
                          Upgrade ke layanan lain (opsional):
                        </Form.Label>
                        <Form.Select
                          size="sm"
                          value={redeemUpgradeServiceId || ""}
                          onChange={(e) =>
                            setRedeemUpgradeServiceId(e.target.value || null)
                          }
                        >
                          <option value="">
                            Ambil gratis — {rule.reward_service_name}
                          </option>
                          {upgradeOptions.map((s) => (
                            <option key={s.id} value={s.id}>
                              {s.name} ({fmt(s.price)}) — bayar{" "}
                              {fmt(s.price - rewardPrice)}
                            </option>
                          ))}
                        </Form.Select>
                        {selectedUpgrade && (
                          <div className="alert alert-info py-2 small mt-2 mb-0">
                            Diskon loyalty{" "}
                            <strong>{fmt(rewardPrice)}</strong> dari{" "}
                            <strong>{fmt(selectedUpgrade.price)}</strong> —
                            bayar selisih{" "}
                            <strong>
                              {fmt(selectedUpgrade.price - rewardPrice)}
                            </strong>
                          </div>
                        )}
                      </div>
                    )}
                  </>
                );
              })()}
              <p className="text-muted small mb-3">
                {redeemReplaceItem
                  ? "Layanan yang Anda pilih sebelumnya akan diganti dengan hadiah loyalty ini."
                  : redeemUpgradeServiceId
                    ? "Layanan upgrade akan ditambahkan ke keranjang dengan diskon loyalty."
                    : "Layanan hadiah akan ditambahkan ke keranjang secara gratis."}
              </p>
              <div className="d-flex gap-2">
                <Button
                  variant="light"
                  className="flex-fill"
                  onClick={() => {
                    setShowRedeemModal(false);
                    setRedeemRuleId("");
                    setRedeemVehicle(null);
                    setRedeemReplaceItem(null);
                    setRedeemUpgradeServiceId(null);
                  }}
                >
                  Batal
                </Button>
                <Button
                  variant="success"
                  className="flex-fill"
                  onClick={handleRedeemLoyalty}
                >
                  🎁{" "}
                  {redeemUpgradeServiceId
                    ? "Klaim & Upgrade"
                    : "Tambah ke Keranjang"}
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}

      <ConfirmModal
        show={confirmModal.show}
        title={confirmModal.title}
        message={confirmModal.message}
        onConfirm={confirmModal.onConfirm}
        onCancel={closeConfirm}
        confirmLabel={confirmModal.confirmLabel}
        confirmVariant={confirmModal.confirmVariant}
        cancelLabel={confirmModal.cancelLabel}
      />
    </div>
  );
};

export default POS;
